import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  Icon,
  IconVariant,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

const features = [
  {
    id: 0,
    text: 'Choose your menu in a few taps',
  },
  {
    id: 1,
    text: 'Meal planning and cooking guidance',
  },
  {
    id: 2,
    text: 'Flexible account for easy subscription management in the app',
  },
  {
    id: 3,
    text: 'Alter your delivery day on the go',
  },
]

function CheckListRow({ description }: { description: string }) {
  return (
    <>
      <Box paddingV={1} display={Display.Flex} flexDirection={FlexDirection.Row}>
        <Icon variant={IconVariant.Confirmation} name="tick" />
        <Space direction="horizontal" size={2} />
        <Body2 size={4} color={Color.White}>
          {description}
        </Body2>
      </Box>
    </>
  )
}

export function MealPlanningBannerSection() {
  return (
    <Box
      paddingH={[8, 20]}
      paddingV={16}
      display={Display.Flex}
      bg={Color.ColdGrey_800}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
    >
      <Box paddingH={4}>
        <Heading2 textAlign={TextAlign.Left} color={Color.White}>
          Meal planning made easy with our app
        </Heading2>
        <Space size={2} />
        <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
          {features.map((feature) => {
            return <CheckListRow key={feature.id} description={feature.text} />
          })}
        </Box>
      </Box>
    </Box>
  )
}
